import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetMainArticlesSucceed, EGetMainArticlesActionType } from './types';
import { IArticlesMainDataSchema } from '../../../repositories/journal/entities/journal/ArticlesMainDataSchema';

export const getMainArticlesSucceed: (articles: IArticlesMainDataSchema[]) => TGetMainArticlesSucceed = actionGenerator<
  EGetMainArticlesActionType.Succeed,
  IArticlesMainDataSchema[]
>(EGetMainArticlesActionType.Succeed);
